import * as React from "react";
import {IAdvicePrescription} from "@curefit/care-common";

interface LifestyleAdviceViewProps {
    advices: IAdvicePrescription[];
    doctorAdvices: IAdvicePrescription[];
}
const LifestyleAdviceView: React.StatelessComponent<LifestyleAdviceViewProps> = (props: LifestyleAdviceViewProps) => {
    return <div className={"medicine-prescription-view-container"}>
        <table style={{tableLayout: "auto", width: "55%"}}>
            <thead>
            <tr>
                <th className={"brandon-bold"}>ADVICE</th>
            </tr>
            </thead>
            {props.advices &&
                <tbody>
                {props.advices && props.advices.map((advice, index) => {
                    return <tr key={index}>
                        <td>{advice.lifestyleAdvice && advice.lifestyleAdvice.displayValue}</td>
                    </tr>
                })}
                </tbody>
            }
               {props.doctorAdvices &&
                <tbody>
                {props.doctorAdvices && props.doctorAdvices.map((advice, index) => {
                    return <tr key={index}>
                        <td>{advice.doctorAdvice && advice.doctorAdvice.displayValue}</td>
                    </tr>
                })}
                </tbody>
            }
        </table>
    </div>
}

export default LifestyleAdviceView;